import React from "react";
import { createPortal } from "react-dom";

/**
 * Full-screen modal rendered on document.body (avoids app-shell clipping / z-index issues).
 */
export default function FeedbackModal({
  open,
  title,
  children,
  onClose,
  primaryLabel = "OK",
  onPrimary,
}) {
  if (!open || typeof document === "undefined") return null;

  const handlePrimary = () => {
    if (onPrimary) onPrimary();
    else if (onClose) onClose();
  };

  return createPortal(
    <div
      className="modal-backdrop feedback-modal-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="modal-card modal-card-elevated feedback-modal-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="feedback-modal-title"
      >
        <button type="button" className="close-btn" aria-label="Close" onClick={onClose}>
          ×
        </button>
        {title ? (
          <h3 id="feedback-modal-title" style={{ marginTop: 0, marginBottom: 8 }}>
            {title}
          </h3>
        ) : null}
        {children}
        <div
          style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}
        >
          <button type="button" onClick={handlePrimary}>
            {primaryLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
